import React from 'react'
import cardBack from 'assets/cardBack.svg'

function CardBack({ ...props }) {
	return (
		<div {...props}>
			<img width='100%' height='100%' src={cardBack} alt='' />
		</div>
	)
}

export default CardBack
